import { CustomPlaceholder } from "@pulse/pulse-rpcs/lib/email-cycle/customPlaceholder";
import { GetCustomPlaceholdersRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getCustomPlaceholdersRPC";
import { mockExecute } from "@pulse/shared-components";
import { LeoRPCResult } from "@surya-digital/leo-ts-types";

const MOCK_CUSTOM_PLACEHOLDERS = [
  new CustomPlaceholder("First Name", "first_name"),
  new CustomPlaceholder("Last Name", "last_name"),
  new CustomPlaceholder("User Name", "user_name"),
  new CustomPlaceholder("Email ID", "email_id"),
  new CustomPlaceholder("Phone Number", "phone_number"),
  new CustomPlaceholder("Survey URL", "survey_url"),
  new CustomPlaceholder("Department", "department"),
];

export class MockGetCustomPlaceholdersRPCClientImpl extends GetCustomPlaceholdersRPC {
  execute(): Promise<
    LeoRPCResult<
      GetCustomPlaceholdersRPC.Response,
      GetCustomPlaceholdersRPC.Errors.Errors
    >
  > {
    return mockExecute({
      response: new GetCustomPlaceholdersRPC.Response(MOCK_CUSTOM_PLACEHOLDERS),
    }) as Promise<
      LeoRPCResult<
        GetCustomPlaceholdersRPC.Response,
        GetCustomPlaceholdersRPC.Errors.Errors
      >
    >;
  }
}
